import {
  FETCH_TRIPMASTER_REQUEST,
  FETCH_TRIPMASTER_SUCCESS,
  FETCH_TRIPMASTER_FAILURE,
  SAVE_TRIPMASTER_REQUEST,
  SAVE_TRIPMASTER_SUCCESS,
  SAVE_TRIPMASTER_FAILURE,
  DELETE_TRIPMASTER_REQUEST,
  DELETE_TRIPMASTER_SUCCESS,
  DELETE_TRIPMASTER_FAILURE,
} from "./actionTypes";

const initialState = {
  loading: false,
  tripmasterList: [],
  data: null,
  deleteResponse: null,
  error: null,
  success: false,
};

const tripmasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TRIPMASTER_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case FETCH_TRIPMASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        tripmasterList: action.payload.data || [],
        success: false,
      };

    case FETCH_TRIPMASTER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case SAVE_TRIPMASTER_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case SAVE_TRIPMASTER_SUCCESS:
      return { ...state, loading: false, data: action.payload, success: true };

    case SAVE_TRIPMASTER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_TRIPMASTER_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case DELETE_TRIPMASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteResponse: action.payload,
        success: true,
      };

    case DELETE_TRIPMASTER_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default tripmasterReducer;
